<template>
  <section class="circuit-mode-section">
    <div class="circuit-mode-section__header">
      <h4
        class="circuit-mode-section__title"
        v-text="$tc('HomePage.countdown.circuitMode.title')"
      />
      <button
        class="circuit-mode-section__toggle-button"
        :class="{ 'circuit-mode-section__toggle-button--active': isCircuitMode }"
        @click="toggleCircuitMode"
      >
        <span class="circuit-mode-section__toggle-button-label" v-text="$tc('common.on')" />
        <span class="circuit-mode-section__toggle-button-label" v-text="$tc('common.off')" />
        <span class="circuit-mode-section__toggle-button-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="55"
            height="16"
            viewBox="0 0 55 16"
            fill="none"
          >
            <g clip-path="url(#clip0_16137_154590)">
              <path
                d="M48.3061 0C45.3233 0 42.1136 0.890076 42.1136 2.84317V10.9665C42.1136 10.9805 42.1175 10.9932 42.1178 11.007H40.7396V2.556C40.7396 2.107 40.3763 1.74366 39.9273 1.74366H34.3171C34.0799 1.74366 33.8546 1.84758 33.6999 2.02846C33.5452 2.20854 33.4778 2.44811 33.5143 2.68214C33.6313 3.42824 33.7426 5.2607 33.2577 6.48644C32.0255 2.00129 24.496 0.526459 24.1486 0.460911C23.9114 0.4149 23.6663 0.479156 23.4791 0.633849C23.2934 0.787746 23.1856 1.01701 23.1856 1.25897V2.12177C21.1833 2.37106 19.6229 4.06436 19.6229 6.13298V6.3788C19.101 6.54778 18.787 6.67911 18.6786 6.72666C16.3067 5.90084 13.9869 5.96158 12.2309 6.13694C6.30659 6.73033 0.904244 11.8273 0.677367 12.0438C0.436997 12.2731 0.36084 12.6253 0.483803 12.9339C0.607555 13.2417 0.905836 13.444 1.23823 13.444H6.64628C7.38846 14.4245 8.55326 15.0687 9.87485 15.0687C11.1964 15.0687 12.3612 14.4245 13.1034 13.444H29.3709C29.3772 13.444 29.3825 13.4406 29.3888 13.4405C30.1308 14.423 31.297 15.0687 32.6203 15.0687C34.8597 15.0687 36.6819 13.2465 36.6819 11.007C36.6819 9.48584 35.8313 8.17308 34.5902 7.47727C35.2597 6.154 35.2909 4.43349 35.2199 3.36833H39.115V11.007H37.4927V12.6317H43.1522C43.7445 13.0305 44.5439 13.325 45.4411 13.5189C45.6567 14.9199 46.8601 16 48.3204 16C49.7838 16 50.9885 14.9164 51.2011 13.512C53.0526 13.1063 54.4994 12.2767 54.4994 10.9665V2.84317C54.4994 0.890076 51.2889 0 48.3061 0ZM30.1832 11.007C30.1832 9.66314 31.2764 8.56998 32.6202 8.56998C33.9641 8.56998 35.0573 9.66314 35.0573 11.007C35.0573 12.3508 33.9641 13.444 32.6202 13.444C31.2764 13.444 30.1832 12.3508 30.1832 11.007ZM23.1856 3.74817V5.57529C22.4615 5.68178 21.8237 5.80539 21.2678 5.93242C21.3578 4.85116 22.1451 3.96564 23.1856 3.74817ZM9.87484 13.444C8.531 13.444 7.43784 12.3508 7.43784 11.007C7.43784 9.66314 8.531 8.56998 9.87484 8.56998C11.2187 8.56998 12.3119 9.66314 12.3119 11.007C12.3119 12.3508 11.2187 13.444 9.87484 13.444ZM3.47928 11.8193C4.13613 11.3175 4.96771 10.7369 5.90132 10.1718C5.84465 10.4416 5.81316 10.7206 5.81316 11.007C5.81316 11.2851 5.84173 11.5567 5.89527 11.8193H3.47928ZM13.8544 11.8193C13.908 11.5567 13.9365 11.2851 13.9365 11.007C13.9365 9.67995 13.2875 8.51048 12.3002 7.7688C12.3312 7.76543 12.3617 7.7568 12.3928 7.75367C16.1673 7.37527 18.8827 8.06306 21.1825 9.98363C22.1035 10.7531 23.0507 11.3529 23.9566 11.8193H13.8544ZM22.2233 8.73657C21.7581 8.34801 21.2842 8.01616 20.8066 7.72656C22.1987 7.34464 24.5289 6.88264 27.6867 6.88264V5.25797C26.6412 5.25797 25.683 5.30621 24.8102 5.38405V2.28548C26.7708 2.80643 31.0831 4.25945 31.7207 7.05349C29.9141 7.46502 28.5586 9.07759 28.5586 11.007C28.5586 11.2472 28.5892 11.4796 28.6295 11.7085C27.3342 11.4743 24.6606 10.7717 22.2233 8.73657ZM52.8739 2.84317C52.789 3.21126 51.1477 4.06168 48.3061 4.06168C45.4534 4.06168 43.8113 3.20492 43.7383 2.84794C43.8121 2.48222 45.4558 1.62467 48.3061 1.62467C51.1453 1.62467 52.7874 2.47509 52.8739 2.84317ZM49.6206 13.0759C49.6206 13.7923 49.0375 14.3753 48.3204 14.3753C47.604 14.3753 47.021 13.7923 47.021 13.0759C47.021 12.3588 47.604 11.7757 48.3204 11.7757C49.0375 11.7757 49.6206 12.3588 49.6206 13.0759ZM52.872 10.9669C52.82 11.196 52.1651 11.6118 50.9905 11.8934C50.8343 11.5423 50.6112 11.2291 50.337 10.9669C49.8115 10.4643 49.1032 10.151 48.3204 10.151C47.5379 10.151 46.8298 10.4643 46.3045 10.9669C46.0288 11.2306 45.8042 11.5455 45.6479 11.8991C44.452 11.6163 43.7849 11.1943 43.7385 10.9669C43.7385 10.9668 43.7385 10.967 43.7385 10.9669L43.7383 8.90302C44.9451 9.47499 46.6589 9.74803 48.3061 9.74803C49.9534 9.74803 51.6677 9.47499 52.8747 8.90287V10.9626C52.8745 10.9638 52.8723 10.9656 52.872 10.9669ZM52.872 6.9052C52.7885 7.27305 51.149 8.12336 48.3061 8.12336C45.4542 8.12336 43.8124 7.26714 43.7385 6.9052C43.7385 6.90511 43.7385 6.9053 43.7385 6.9052L43.7383 4.84134C44.9451 5.41331 46.6589 5.68635 48.3061 5.68635C49.9534 5.68635 51.6676 5.41331 52.8747 4.84119V6.90088C52.8744 6.90212 52.8723 6.90396 52.872 6.9052Z"
                fill="url(#paint0_linear_16137_154590)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_16137_154590"
                x1="0.425781"
                y1="8"
                x2="58.3401"
                y2="7.99999"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#7D2EA3" />
                <stop offset="0.677083" stop-color="#CA8CE8" />
                <stop offset="1" stop-color="#7D2EA3" />
              </linearGradient>
              <clipPath id="clip0_16137_154590">
                <rect width="54.0736" height="16" fill="white" transform="translate(0.425781)" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </button>
    </div>
    <p class="circuit-mode-section__description" v-html="circuitModeExplanationText" />

    <onboarding-circuit-mode-section
      v-if="!hasDisplayedOnboarding"
      @close="$emit('onCloseOnboardingScreen')"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent, watch, Ref, ref } from '@vue/composition-api'
import StoreUtil from '@/store/StoreUtil'
import OnboardingCircuitModeSection from '@/components/HomePage/HomePane/OnboardingCircuitModeSection.vue'
import I18n from '@/locales/I18n'
import Const from '@/util/Const'

/**
 * HOME サーキットモード切り替えセクション
 */
export default defineComponent({
  name: 'CircuitModeSection',
  components: {
    OnboardingCircuitModeSection,
  },
  props: {
    /**
     * アプリインストール後、オンボーディング画面を表示したかどうか
     */
    hasDisplayedOnboarding: {
      type: Boolean,
    },
  },
  setup(props) {
    const appConfigStore = StoreUtil.useStore('AppConfigStore')
    /**
     * サーキットモード説明テキストとリンク
     */
    const circuitModeExplanationText: Ref<string> = ref('')

    const setCircuitModeExplanationText = () => {
      const description = props.hasDisplayedOnboarding
        ? 'HomePage.countdown.circuitMode.description'
        : 'HomePage.countdown.circuitMode.onboarding.shortDescription'
      circuitModeExplanationText.value = I18n.t(description, {
        url:
          I18n.locale === 'ja'
            ? Const.EXTERNAL_LINKS.ABOUT_MEMBER_RANK.JA
            : Const.EXTERNAL_LINKS.ABOUT_MEMBER_RANK.EN,
      }).toString()
    }
    setCircuitModeExplanationText()

    watch(
      () => props.hasDisplayedOnboarding,
      () => {
        setCircuitModeExplanationText()
      },
    )

    /**
     * サーキットモード切り替え
     */
    const toggleCircuitMode = () => {
      appConfigStore.currentCircuitMode.value = !appConfigStore.currentCircuitMode.value
    }

    return {
      isCircuitMode: appConfigStore.currentCircuitMode,
      toggleCircuitMode,
      circuitModeExplanationText,
    }
  },
})
</script>

<style lang="scss" scoped>
.circuit-mode-section {
  position: relative;
  width: calc(100% - 24px);
  margin: 0 auto;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid $black10;
  background: #eeeded;
  text-align: left;
  color: var(--transparent-black-50, rgba(0, 0, 0, 0.5));
  font-feature-settings: 'palt' on;
  @include fontSetTextSmall();

  line-height: 1.4;

  &__header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 13px;
    margin-bottom: 12px;
    border-bottom: 1px solid $black05;
  }

  &__title {
    color: $black;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.667;
    letter-spacing: 0.02em;
  }

  &__toggle-button {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 115px;
    height: 34px;
    border-radius: 50px;
    background: $gray20;
    color: $white;

    &-label {
      display: inline-block;
      padding: 0 11px;
      width: 52px;
      @include fontSetTextMedium();

      text-align: center;
      font-family: $fontFamilyDefault;
      letter-spacing: 0.04em;
    }

    &-icon {
      position: absolute;
      left: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 66px;
      height: 28px;
      border-radius: 50px;
      background: $white;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
      transition: transform 0.1s ease-in-out;

      svg {
        width: 55px;
        height: 16px;
      }
    }

    &:not(.circuit-mode-section__toggle-button--active) {
      .circuit-mode-section__toggle-button-icon svg {
        path {
          fill: $gray20;
        }
      }
    }

    &--active {
      background: $purple;

      .circuit-mode-section__toggle-button-icon {
        transform: translateX(43px);
      }
    }
  }
}
</style>

<style lang="scss">
.circuit-mode-section {
  &__description {
    a {
      color: $black !important;
      text-decoration: underline !important;
    }
  }
}
</style>
